<template>
  <AdminSystemsPage />
</template>

<script setup lang="ts">
import { useSeoMeta } from "@unhead/vue";
import AdminSystemsPage from "shared-ui/pages/AdminSystemsPage.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

useSeoMeta({
  title: () => t("admin_systems.title"),
});

definePage({
  meta: {
    requiresAuth: true,
    requiresAdmin: true,
    layout: "AppLayout",
  },
});
</script>
